// removed by extract-text-webpack-plugin
module.exports = {"root":"date-input--root--2F5kjuwQ input--root--3bmcFHMd","focused":"date-input--focused--3rU_oYdo","display":"date-input--display--2RxY6-Km","input":"date-input--input--3_51qY-Z"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/date-input/styles.css
// module id = ./components/forms/date-input/styles.css
// module chunks = 0